var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4842 3.67096C14.3291 2.08409 17.8259 2.11183 20.6441 3.74362C23.4345 5.40864 25.1305 8.38022 25.1147 11.5768C25.0497 14.7524 23.2312 17.7375 20.958 20.0451C19.6459 21.383 18.1782 22.566 16.5848 23.57C16.4206 23.6611 16.2409 23.7221 16.0543 23.75C15.8748 23.7427 15.7 23.6917 15.5456 23.6018C13.1129 22.0932 10.9786 20.1675 9.24555 17.9175C7.79536 16.0392 6.97147 13.77 6.88574 11.418C6.88386 8.21531 8.63934 5.25784 11.4842 3.67096ZM13.1281 12.7434C13.6067 13.876 14.7362 14.6147 15.9894 14.6147C16.8104 14.6204 17.5995 14.3047 18.1811 13.738C18.7626 13.1713 19.0882 12.4007 19.0853 11.5979C19.0897 10.3725 18.3382 9.26533 17.1817 8.79341C16.0252 8.32148 14.6918 8.57788 13.8041 9.44287C12.9165 10.3079 12.6496 11.6108 13.1281 12.7434Z",
    fill: "#C2B58C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.0007 27.5C19.5963 27.5 22.5111 26.9404 22.5111 26.25C22.5111 25.5596 19.5963 25 16.0007 25C12.405 25 9.49023 25.5596 9.49023 26.25C9.49023 26.9404 12.405 27.5 16.0007 27.5Z",
    fill: "#C2B58C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.5a8e1aa62c9dc5ec357fc01c6e3fdfa3.svg";
export { ForwardRef as ReactComponent };